import httpClient from "@/plugins/axios";

export const getBenefits = async () => {
    const response = await httpClient.get('/v1/benefits/?admin_view=1&translations=true');
    return response;
}

export const sort = async (sortedIds) => {
    const response = await httpClient.put('/v1/benefits/sort/?admin_view=1', sortedIds);
    return response;
}

export const getBenefit = async (id) => {
    const response = await httpClient.get(`/v1/benefits/${id}/?admin_view=1&translations=1`);
    return response;
}

export const saveBenefit = async (benefit, newLogoBlob, newLogoName, removeLogo, newCouponBlob, newCouponName, removeCoupon) => {
    const formData = getFormData(benefit, newLogoBlob, newLogoName, removeLogo, newCouponBlob, newCouponName, removeCoupon);
    if (benefit.id) {
        return await updateBenefit(benefit.id, formData);
    }
    else {
        return await insertBenefit(formData);
    }
};

const insertBenefit = async (formData) => {
    const response = await httpClient.post('/v1/benefits/?admin_view=1', formData)
    return response;
}

const updateBenefit = async (id, formData) => {
    const response = await httpClient.put(`/v1/benefits/${id}/?admin_view=1`, formData);
    return response;
}

export const deleteBenefit = async (id) => {
    const response = await httpClient.delete(`/v1/benefits/${id}/?admin_view=1`)
    return response;
}

const getFormData = (benefit, newLogoBlob, newLogoName, removeLogo, newCouponBlob, newCouponName, removeCoupon) => {
    const formData = new FormData()
    if (benefit.id) {
        formData.append('id', benefit.id)
    }
    formData.append('company', benefit.company)
    formData.append('published', benefit.published)
    formData.append('translations', JSON.stringify(benefit.translations))


    if (newLogoBlob) {
        formData.append('logo', newLogoBlob, newLogoName);
    } else if (removeLogo) {
        formData.append('remove_logo', true)
    }

    if (newCouponBlob) {
        formData.append('coupon_image', newCouponBlob, newCouponName);
    } else if (removeCoupon) {
        formData.append('remove_coupon_image', true)
    }

    return formData;
}